import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from '@sea-snag/ui';
import { useQuery } from '@tanstack/react-query';

import { useOrganization } from '../../contexts/organization-context';
import { boatsApi } from '../../lib/api-client';
import { queryKeys } from '../../lib/query-keys';

interface AnalyticsFiltersProps {
  boatPid: string;
  onBoatPidChange: (boatPid: string) => void;
  showBoatFilter?: boolean;
}

/** Year is not here — it is the app-wide control in the header. */
export function AnalyticsFilters({
  boatPid,
  onBoatPidChange,
  showBoatFilter = true,
}: AnalyticsFiltersProps) {
  const { organization } = useOrganization();
  const orgPid = organization?.pid ?? '';
  const { data: boatsData } = useQuery({
    queryKey: queryKeys.boats.list(orgPid, 'analytics-filter'),
    queryFn: () => boatsApi.list({ limit: 100 }),
    enabled: !!orgPid && showBoatFilter,
  });

  const boats = boatsData?.data ?? [];

  return (
    <div className="flex items-center gap-3">
      {showBoatFilter && (
        <Select value={boatPid} onValueChange={onBoatPidChange}>
          <SelectTrigger className="w-[200px]">
            <SelectValue placeholder="All boats" />
          </SelectTrigger>
          <SelectContent>
            <SelectItem value="all">All boats</SelectItem>
            {boats.map((boat) => (
              <SelectItem key={boat.id} value={boat.id}>
                {boat.name}
              </SelectItem>
            ))}
          </SelectContent>
        </Select>
      )}
    </div>
  );
}
